import React from 'react';

import Section from '../../Section';
import Tile from '../../Tile';
import TagGrid from '../../TagGrid';

const logos = [
  'facet-battery',
  'facet-camera',
  'facet-checkmark',
  'facet-eye',
  'facet-floppy',
  'facet-frown',
  'facet-gears',
  'facet-hourglass',
  'facet-lock',
  'facet-screen',
  'facet-smile',
  'facet-wifi',
  'bw-batman',
  'bw-k',
  'bw-puzzle',
  'bw-r'
]

export default function Logos(props) {

  return <Section>
    <a name="logos" />
    <h1 className="h3 mdl-typography--display-1-color-contrast">Logos</h1>
    <TagGrid title='Logos' tag={Tile} source={logos} path='/images/logos/facets/'/>
  </Section>
}



// WEBPACK FOOTER //
// ./src/Pages/Logos/Logos.js